// dashboard-agent-ia/src/pages/PaymentCancel.js
import React, { useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'

export default function PaymentCancel() {
  const [searchParams] = useSearchParams()
  const businessId = searchParams.get('businessId')

  useEffect(() => {
    // Si on est dans un popup, fermer la fenêtre automatiquement
    if (window.opener) {
      window.close()
    }
  }, [])

  // Si popup fermé automatiquement, cette page ne s'affiche pas
  // Sinon afficher une page propre
  return (
    <div style={{ background: 'linear-gradient(135deg,#0f172a,#1e1b4b,#0f172a)', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
      <div style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 24, padding: 'clamp(30px,5vw,60px) clamp(20px,4vw,48px)', maxWidth: 480, width: '90%', textAlign: 'center' }}>
        <div style={{ fontSize: 72, marginBottom: 24 }}>😔</div>
        <h2 style={{ color: 'white', fontSize: 32, fontWeight: 800, marginBottom: 12 }}>Paiement annulé</h2>
        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 16, marginBottom: 40 }}>
          Votre paiement a été annulé. Aucun montant n'a été prélevé.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          {businessId ? (
            <Link to="/business-dashboard" style={{ background: '#3b82f6', color: 'white', padding: '14px 28px', borderRadius: 12, textDecoration: 'none', fontWeight: 700 }}>
              Retour au dashboard
            </Link>
          ) : (
            <Link to="/" style={{ background: '#3b82f6', color: 'white', padding: '14px 28px', borderRadius: 12, textDecoration: 'none', fontWeight: 700 }}>
              Retour à l'accueil
            </Link>
          )}
          <a href="https://wa.me/221776480068" style={{ background: '#25d366', color: 'white', padding: '14px 28px', borderRadius: 12, textDecoration: 'none', fontWeight: 700 }}>
            Besoin d'aide ?
          </a>
        </div>
      </div>
    </div>
  )
}
